import React, { useEffect, useState } from 'react';
import './CookieConsent.css';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h3>Cookie Consent</h3>
          <p>
            We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
            By accepting, you consent to our use of cookies in accordance with our{' '}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button 
            className="cookie-btn cookie-accept" 
            onClick={handleAccept}
          >
            Accept All
          </button>
          <button 
            className="cookie-btn cookie-decline" 
            onClick={handleDecline}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
